export default __webpack_public_path__ + "assets/icons/delete.fdfa6096.svg";